<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('price_lists')">Cenniki</inertia-link>
      <span class="text-shtax-400 font-medium">/</span> Nowy cennik
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden md:overflow-visible max-w-3xl">
      <form @submit.prevent="store" class="z-0">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">

          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full" label="Nazwa" />

          <multiselect-input v-model="form.type" :error="form.errors.type" class="pr-6 pb-8 w-full lg:w-full" label="Rodzaj" :options="types" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" @input="onChange" />

          <text-input v-model="form.active_from" :error="form.errors.active_from" class="pr-6 pb-8 w-full lg:w-1/2" label="Od dnia" type="date" />
          <text-input v-model="form.active_to" :error="form.errors.active_to" class="pr-6 pb-8 w-full lg:w-1/2" label="Do dnia" type="date" />

          <div class="pb-8 pr-6 w-full">
            <label class="form-label">Szczegóły:</label>
            <vue-editor v-model="form.details" />

            <div class="w-1/2 form-error">
              <span v-if="form.errors.details">{{ form.errors.details }}</span>
            </div>
          </div>

        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center rounded-b-md">
          <loading-button :loading="form.processing" class="btn-shtax" type="submit">Dodaj cennik</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import MultiselectInput from '@/ShtaxComponents/MultiselectInput'
import { VueEditor } from "vue2-editor";

export default {
  metaInfo: { title: 'Nowy cennik' },
  components: {
    LoadingButton,
    TextInput,
    VueEditor,
    MultiselectInput
  },
  layout: Layout,
  props: {
    types: Array
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: null,
        active_from: null,
        active_to: null,
        type: this.types.at(0),
        details: this.types.at(0).details,
      })
    }
  },
  methods: {
    store() {
      this.form.post(this.route('price_lists.store'))
    },
    onChange (value) {
      this.form.details = value.details
    },
  }
}
</script>
